import { Funnel } from "@phosphor-icons/react"
import {
  Button,
  CodenameTag,
  FilterDrawer,
  FormQuerySelector,
} from "@vesatogo/grass-core"
import { FormDateInput } from "@vesatogo/grass-dates"
import { Dispatch, SetStateAction, useState } from "react"
import { Permission } from "~/constants/Permissions"
import {
  useAllCreditStatusQuery,
  useAuthenticatedUserQuery,
  useSearchBaseUsersQuery,
} from "~/generated/graphql"

export type CreditFilterType = {
  date_from?: any
  date_to?: any
  seller?: any
  performed_by?: any
  verified_by?: any
  status?: any
}

type CreditFilterProps = {
  filter: CreditFilterType
  setFilter: Dispatch<SetStateAction<CreditFilterType>>
}
const CreditFilter = ({ filter, setFilter }: CreditFilterProps) => {
  const [isOpen, setOpen] = useState(false)

  function inputProps(path: string) {
    return {
      value: filter[path],
      onChange: (e: any) => {
        setFilter(prev => ({
          ...prev,
          [path]: e?.target ? e.target.value : e,
        }))
      },
    }
  }

  function getAppliedFilters(prefix: string, filter: any) {
    const totalApplied = Object.keys(filter)?.filter?.(
      key => key.startsWith(prefix) && filter[key]
    )?.length
    return totalApplied ? `${totalApplied} Applied` : null
  }

  const [{ data }] = useAuthenticatedUserQuery()
  const me = data?.me

  const buyerGroups = ["Trader"]
  if (me?.permissions?.includes(Permission.SelectFarmerInBuyer)) {
    buyerGroups.push("Farmer")
  }

  return (
    <>
      <Button
        onClick={() => {
          setOpen(prev => !prev)
        }}
        variant={Object.values(filter)?.length > 0 ? "solid" : "outline"}
        className="items-center"
      >
        <Funnel />
      </Button>
      <FilterDrawer
        tabs={[
          {
            id: 3,
            title: "Basic",
            subtitle: getAppliedFilters("oth", filter),
            content: (
              <div className="flex flex-col gap-3">
                <FormDateInput
                  label="Created From"
                  {...inputProps("date_from")}
                />
                <FormDateInput label="Created To" {...inputProps("date_to")} />
                <FormQuerySelector
                  label="Status"
                  dataHook={useAllCreditStatusQuery}
                  {...inputProps("status")}
                  getOptionLabel={op => op?.id}
                  variables={{
                    where: {
                      is_actionable: { _eq: true },
                    },
                  }}
                />
                <FormQuerySelector
                  serverSideQuery
                  label="Approved By"
                  dataHook={useSearchBaseUsersQuery}
                  variables={{ groups: ["Farmer", "Trader"] }}
                  {...inputProps("verified_by")}
                  getOptionLabel={option => {
                    if (option === filter?.verified_by) {
                      return option?.name
                    }
                    return (
                      <>
                        <div>{option?.name}</div>
                        <CodenameTag
                          referenceId={option?.external_reference_id}
                        ></CodenameTag>
                      </>
                    )
                  }}
                />
              </div>
            ),
          },
        ]}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onApply={() => {
          setOpen(false)
        }}
        onClearAll={() => {
          setFilter({})
          setOpen(false)
        }}
      />
    </>
  )
}

export default CreditFilter
